module.exports = __webpack_public_path__ + "img/teaser_training8.cb62b265.jpg";